import React from "react";
import "./At_Printout_Media.css";
import Homepage_common_heading from "../../Common-Component/Homepage_common_heading/Homepage_common_heading";

function At_Printout_Media() {
  return (
    <>
      <section className="At_Printout_Media">
        <div className="custom_container">
          <div className="apm_wrapper">
            <div className="row">
              <div className="col-md-5">
                {/* LEFT SIDE IMAGES */}
                <div className="apm_left">
                  <div className="apm_img_large">
                    <img
                      src="/assets/Images/Home/At_Printout_Media/img_1.png"
                      alt="print"
                    />
                  </div>

                  <div className="apm_img_right">
                    <div className="apm_img_small">
                      <img
                        src="/assets/Images/Home/At_Printout_Media/img_2.png"
                        alt="print"
                      />
                    </div>

                    <div className="apm_img_small">
                      <img
                        src="/assets/Images/Home/At_Printout_Media/img_3.png"
                        alt="print"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                {/* RIGHT SIDE CONTENT */}
                <div className="apm_right">
                  <Homepage_common_heading
                    headingText={"At Printout Media,"}
                    headingDescText={
                      " We Turn Your Ideas Into High-Quality, Customized Products."
                    }
                  />

                  <p className="apm_desc">
                   From business essentials like stationery, brochures, and visiting cards to personalized gifts, apparel, and promotional items, we provide creative olutions that make your brand stand out. Whether you’re a business or an individual, we’re here to bring your vision to life.
                  </p>

                  <div className="apm_features">
                    <div className="apm_feature">
                      <span></span>
                      <div>
                        <h4>High-Quality Printing</h4>
                        <p>Premium materials and sharp finishes.</p>
                      </div>
                    </div>

                    <div className="apm_feature">
                      <span></span>
                      <div>
                        <h4>Fully Customizable Products</h4>
                        <p>Designs tailored to your brand.</p>
                      </div>
                    </div>

                    <div className="apm_feature">
                      <span></span>
                      <div>
                        <h4>Wide Product Range</h4>
                        <p>From stationery to gifts.</p>
                      </div>
                    </div>

                    <div className="apm_feature">
                      <span></span>
                      <div>
                        <h4>Fast & Reliable Service</h4>
                        <p>Quick delivery and support.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default At_Printout_Media;
